import { Box, Button, IconButton, InputAdornment, Modal, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { GrClose } from 'react-icons/gr';
import ResetButton from '../../Common_Components/ResetButton';
import { MdContentCopy } from 'react-icons/md';

const contentStyle = {
    fontFamily: 'Times New Roman',
    fontWeight: '700',
    fontSize: '20px',
    color: '#333',
    lineHeight: '28px',
};

const labelStyle = {
    fontFamily: 'Times New Roman',
    fontWeight: '600',
    fontSize: '18px',
    color: '#555',
    lineHeight: '24px',
    marginRight: '16px',
};

const LicenseViewModal = ({ open, handleClose, licensedetl }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(licensedetl?.GeneratedKey);
        setCopied(true);
        setTimeout(() => setCopied(false), 5000);
    };

    return (
        <Modal open={open} onClose={handleClose}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { xs: '90%', sm: 600, md: 800 },
                    bgcolor: '#f9f9f9',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 3,
                    overflowY: 'auto',
                    maxHeight: '90vh',
                }}
            >
                {/* Header */}
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={3}
                    sx={{ borderBottom: '1px solid #ddd', pb: 2 }}
                >
                    <Typography sx={{ fontFamily: 'Times New Roman', fontWeight: '700', fontSize: '28px', color: '#333' }}>
                        License Details
                    </Typography>
                    <IconButton onClick={handleClose}>
                        <GrClose />
                    </IconButton>
                </Box>

                {/* Product Name */}

                <Box mb={2} display="flex" justifyContent="flex-start">
                    <Typography sx={labelStyle}>Product Name:</Typography>
                    <Typography sx={contentStyle}> {licensedetl?.ProductName}</Typography>
                </Box>
                {/* License Details */}
                <Box mb={2} display="flex" justifyContent="flex-start">
                    <Typography sx={labelStyle}>Version:</Typography>
                    <Typography sx={contentStyle}>{licensedetl?.Version}</Typography>
                </Box>
                <Box mb={2} display="flex" justifyContent="flex-start">
                    <Typography sx={labelStyle}>Client Name:</Typography>
                    <Typography sx={contentStyle}>{licensedetl?.ClientName}</Typography>
                </Box>
                <Box mb={2} display="flex" justifyContent="flex-start">
                    <Typography sx={labelStyle}>License Type:</Typography>
                    <Typography sx={contentStyle}>{licensedetl?.LicenseTypeName}</Typography>
                </Box>
                <Box mb={2} display="flex" justifyContent="flex-start">
                    <Typography sx={labelStyle}>No. of User Licenses:</Typography>
                    <Typography sx={contentStyle}>{licensedetl?.UserLicenseCount}</Typography>
                </Box>

                {/* License Key */}
                <Box mb={3}>
                    <Typography sx={labelStyle}>License Key:</Typography>
                    <TextField
                        sx={{ marginTop: 2 }}
                        value={licensedetl?.GeneratedKey}
                        fullWidth
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={handleCopy}>
                                        <MdContentCopy />
                                    </IconButton>
                                </InputAdornment>
                            ),
                            readOnly: true,
                        }}
                    />
                    {copied && (
                        <Typography sx={{ mt: 1, color: 'green', fontSize: '14px', fontFamily: 'Arial' }}>Copied!</Typography>
                    )}
                </Box>

                {/* Close Button */}
                <Box display="flex" justifyContent="flex-end">
                    <ResetButton label="Close" onClick={handleClose} />
                </Box>
            </Box>
        </Modal>
    );
};

export default LicenseViewModal;
